import * as React from 'react';
import { cn } from '@/lib/utils';
import { Switch } from '@/components/ui/switch';

/**
 * LabeledSwitch — the prototype `Toggle({ on, label, sub })` (exported as
 * `window.WxToggle`). A label/sub on the left, a shadcn `Switch` on the right,
 * separated from the previous row by a top border. Controlled. Reused by AI
 * Policy and Org.
 */
export function LabeledSwitch({
  checked,
  onCheckedChange,
  label,
  sub,
  disabled,
  divider = true,
}: {
  checked: boolean;
  onCheckedChange: (v: boolean) => void;
  label: string;
  sub?: string;
  disabled?: boolean;
  divider?: boolean;
}) {
  return (
    <div
      className={cn(
        'flex items-center gap-3 py-2.5',
        divider && 'border-t border-cs-border',
      )}
    >
      <div className="min-w-0 flex-1">
        <div className="text-[13px] font-semibold text-cs-text-primary">{label}</div>
        {sub && <div className="mt-0.5 text-[11.5px] text-cs-text-muted">{sub}</div>}
      </div>
      <Switch
        checked={checked}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
        aria-label={label}
      />
    </div>
  );
}
